import { render, staticRenderFns } from "./editDeal.vue?vue&type=template&id=40640669&lang=pug"
import script from "./editDeal.vue?vue&type=script&lang=js"
export * from "./editDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports